<template>
  <el-date-picker
    v-if="!isImport(item)"
    size="mini"
    v-model.lazy="item.cod"
    type="date"
    format="MM/dd/yy"
    :value-format="'yyyy-MM-dd'"
    @change="$emit('columnEvent', 'autoSave', item, 'rail_cutoff_date', $event)"
    style="width: 90px"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: "order-status-cod",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
